module.exports = __webpack_public_path__ + "img/49.9581ac86.jpg";